import React from 'react'
import { Text, Box } from 'grommet'

const Send = ({ text = '', onSend = () => {}, label = 'Send' }) => {
  if (text.trim().length > 0) {
    return (
      <Box
        onClick={() => {
          onSend({ text: text.trim() }, true)
        }}>
        <Text style={styles.text}>{label}</Text>
      </Box>
    )
  }
  return <Box />
}

export default Send

const styles = {
  container: {
    height: 44,
    justifyContent: 'flex-end',
    backgroundColor: 'white'
  },
  text: {
    color: '#0084ff',
    fontWeight: 'bold',
    fontSize: 17,
    backgroundColor: 'transparent',
    marginBottom: 12,
    marginLeft: 10,
    marginRight: 10
  }
}
